import React, { Component } from 'react';
import createHistory from 'history/createHashHistory';
import $ from 'jquery';
import "./../style.css";
import { Form, Row, Col, Icon, Input, Button, message, Upload, Select, InputNumber } from 'antd';
import { Hcurl } from "./../../../../../constants/index";//获取公共路径
import EventSet from "./../../../../../assets/PubJs/hcPub";//公用的所有事件
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

var CI_Code = EventSet.getQueryString('CI_Code'); //登记单编号
var comCode = EventSet.getQueryString('ComCode'); //企业编号
var CP_Result = EventSet.getQueryString('CP_Result'); //和解结果
var filePath = '';
//const history = createHistory();
let _Correction = null;
var userIp = localStorage.getItem('userIp');
let timeout;
//var webUrl = 'http://211.149.250.2:20001/wisdom315_BusinessAPI/api/Business/';
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataName: '',
            value: '',
            value2: '',
            disabled: "",
            autoHeight: "",
            loading: false,
            locationValue: "",//上级页面传过来的CI_Code
            comCode: "",//上级页面传过来的CI_DealDeapartCode-企业code
            dataName: '',
            fileList: [],
            HanderName: [],//经办人
            HeaderName: [],//负责人
            previewImage: '',
            UserIp: "",//用户IP
            neirong: "和解内容",
            focus: false
        };
    }

    //获取更改内容数据
    GetHeaderName = () => {
        let _this = this
        $.ajax({
            url: Hcurl + "/Business/GetBusinessPending?CI_Code=" + _Correction.state.locationValue,
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                console.log(data, '获取已反馈信息')
                if (data.length !== 0 && data != null) {
                    _Correction.props.form.setFieldsValue({
                        content: data[0].CP_Result,
                        CP_HanderName: data[0].CP_HanderName,
                        CP_HanderPhone: data[0].CP_HanderPhone,
                        CP_HeaderName: data[0].CP_HeaderName,
                        CP_HeaderPhone: data[0].CP_HeaderPhone,
                        CP_Content: data[0].CP_Content,
                        CP_DisputeMoney1: data[0].CP_DisputeMoney,
                        CP_RedeemLoss1: data[0].CP_RedeemLoss,
                    })
                    if (data[0].CP_Attachs !== "" && data[0].CP_Attachs != null) {
                        const allImage = data[0].CP_Attachs.split(";")
                        console.log(allImage)
                        var arr = '{"filelist":[';
                        for (var i = 0; i < allImage.length; i++) {
                            //arr += '{"uid":"' + i + '","name":"' + allImage[i].split('_')[1] + '","status":"done","url":{"Url":"' + allImage[i] + '"}},';

                            arr += '{"uid":"' + i + '","name":"' + _this.fileName(allImage[i],['doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'bmp', 'txt', 'JPG', 'gif', 'GIF', 'svg', 'rm', 'rmvb', 'mpeg', 'avi', 'mp4', '3gp', 'flv', 'wmv', 'swf', 'mpg', '3gp2', 'asf', 'mpeg1', 'mpeg2', 'mpeg3', 'mpeg4', 'h264', 'flv1', 'ppt', 'pptx', 'vsd', 'pot', 'pps', 'rtf', 'wps', 'et', 'dps', 'txt', 'epub', 'rar', 'rar5', 'zip', '7z','BMP','JFIF','bmp','jfif','ico','tif','webp']) + '","status":"done","url":"' + allImage[i] + '"},';
                        }
                        arr = arr.substring(0, arr.length - 1) + "]}";
                        arr = JSON.parse(arr).filelist;
                        //console.log(arr, 'arr');
                        _Correction.setState({
                            fileList: arr
                        })

                    }

                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                //console.log(data)
            }
        })
    }
    fileName(url,array){
        url = url || "";
        let fileName = "";
        if(url)
        {
            array.forEach(keys=>{
                if(url.indexOf(keys)>-1)
                {
                    fileName = url.substring(url.split('').map((item,index)=>{if(item == '/'){return index}}).filter(item=>{if(item){return item}})[url.split('').map((item,index)=>{if(item == '/'){return index}}).filter(item=>{if(item){return item}}).length-1]+1,url.indexOf(keys)-1)+'.'+keys
                }
            })
        }
        return fileName;
      }

    //内容区域高度自适应
    autoHeight = () => {
        let autoHeight = window.innerHeight - 370;
        this.setState({
            autoHeight: autoHeight
        })
    }
    componentDidMount() {
        //this.getIp();  //获取外网ip
        _Correction = this;
        //console.log(decodeURI(CI_Code), decodeURI(comCode), decodeURI(CP_Result));
        ////console.log(decodeURI(window.location.href.split('?')[1].split('&')[1].split('=')[1]));
        ////console.log(decodeURI(window.location.href.split('?')[1].split('&')[2].split('=')[1]));
        this.setState({
            locationValue: decodeURI(CI_Code),  //CI——code
            comCode: decodeURI(comCode),//企业code
        });
        this.props.form.setFieldsValue({
            content: decodeURI(CP_Result),//和解结果
        })
        if (decodeURI(CP_Result) == '和解失败') {
            this.setState({
                neirong: "争议内容"
            })
        } else {
            this.setState({
                neirong: "和解内容"
            })
        }
        this.autoHeight();
        setTimeout(() => {
            _Correction.GetHeaderName()
        }, 20)

    }
    handleChange = (info) => {  //文件上传方法
        console.log(info.file.type)
        // if(info.file.type.search("image/") == '-1'){
        //     message.error(`文件${info.file.name} 不是合法的图片格式`);
        //     return false
        // }
        // this.setState({
        //     dataName: info.file.name
        // })
        let fileList = info.fileList;
        //console.log(info, "info")
        if (info.file.status != "error") {
            if (info.file.status == "done") {
                message.success(`${info.file.name} 文件上传成功`);
            } else {
                if (info.file.status == "removed") {
                    message.success(`${info.file.name} 文件移除成功`);
                }
            }
            fileList = fileList.map((file) => {
                //console.log(file, 'filfilefilefilefilefilee');
                if (file.response) {
                    file.url = file.response;
                }
                return file;
            });

            if (info.file.size < 20971520 || info.file.size == null) {
                filePath = fileList;
                _Correction.setState({ fileList: filePath });
            } else {
                filePath = _Correction.state.fileList
                _Correction.setState({ fileList: filePath });
            }

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 文件上传失败`);
        }
        //this.setState({ fileList });
        //console.log(_Correction.state.fileList, '454545');
    }

    beforeUpload = (file) => {
        return new Promise((resolve, reject) => {
            const isLt2M = file.size / 1024 / 1024 < 20;
            if (!isLt2M) {
                message.error('单个文件大小最多20M');
                return reject(false)
            } 
            
            // if(file.type.search("image/") == '-1'){
            //     message.error('请上传格式正确的文件！');
            //     return reject(false)
            // }
            return resolve(true);
        })
    
    }

    //确定更正
    SureCorrection = (e) => {
        e.preventDefault();
        const { dispatch, form } = this.props;
        form.validateFields((err, fieldsValue) => {
            if (err) {
                message.warn('请检查后重新尝试');
                return
            };
            this.setState({
                loading: true
            })
            let imageUrl = '';
            //console.log(this.state.fileList, 'this.state.fileList');

            $.each(this.state.fileList, function (ids, txt) {
                //console.log(txt, 'txt');
                if (txt.url !== '')
                    imageUrl += txt.url + ';';
            })
            imageUrl = imageUrl.substring(0, imageUrl.length - 1);
            //console.log(imageUrl, 'imageUrl');
            const values = {
                ...fieldsValue,
            };
            console.log(values, 'values');


            $.ajax({
                url: Hcurl + '/Business/UpdateBusinessPending',
                type: 'post',
                data: {
                    CI_Code: _Correction.state.locationValue,
                    CP_Attachs: imageUrl,
                    CP_Content: values.CP_Content,
                    CP_HeaderPhone: values.CP_HeaderPhone,
                    CP_HeaderName: values.CP_HeaderName,
                    CP_HanderPhone: values.CP_HanderPhone,
                    CP_HanderName: values.CP_HanderName,
                    UserCode: EventSet.getUserInfo().CU_Code,
                    UserIp: userIp,
                    CP_RedeemLoss: values.CP_RedeemLoss1.toString().indexOf('.') > 0 ? values.CP_RedeemLoss1 : values.CP_RedeemLoss1 + '.00',
                    CP_DisputeMoney: values.CP_DisputeMoney1.toString().indexOf('.') > 0 ? values.CP_DisputeMoney1 : values.CP_DisputeMoney1 + '.00',
                },
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    //console.log(data)
                    if (data.indexOf('|') >= 0) {
                        if (data.split('|')[0] === 'true') {
                            message.success(data.split('|')[1])
                            setTimeout(() => {
                                _Correction.WaiveCorrection();
                            }, 300)
                        } else
                            message.warn(data.split('|')[1])
                    }
                    _Correction.setState({
                        loading: false
                    });

                },
                error: function (data) {
                    _Correction.setState({
                        loading: false
                    });
                    //history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    //console.log(data)
                }
            })
        })

    }

    //放弃更正
    WaiveCorrection = () => {
        window.opener = null;
        window.open('', '_self');
        window.close();
        //history.push({
        //    pathname: '/Content/Business/CompormiseListAlready',
        //})
    }

    //负责人模糊匹配
    fetch(value, callback) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        function fake() {
            $.ajax({
                url: Hcurl + "/Business/GetAllComCodePhone?ComCode=" + _Correction.state.comCode + "&UserName=" + value,
                type: "post",
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    //console.log(data)
                    if (data != []) {
                        callback(data);
                    } else {
                        let data = []
                        callback(data);
                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    //console.log(data)
                }
            })
        }
        timeout = setTimeout(fake, 300);
    }
    // 负责人模糊匹配下拉框方法
    HeaderNameChange(value) {
        _Correction.props.form.setFieldsValue({
            CP_HeaderName: value!=undefined? value.replace(/'/g,''):''
        })
        if (value != undefined) {
            _Correction.fetch(value, data => _Correction.setState({ HeaderName: data }));
        }
    }
    // 负责人模糊匹配下拉框方法
    onHeaderName = (value, option) => {
        setTimeout(function () {
            _Correction.props.form.setFieldsValue({
                CP_HeaderPhone: option.key
            })
        }, 20)
    }

    //经办人模糊匹配
    Jfetch(value, callback) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        function fake() {
            $.ajax({
                url: Hcurl + "/Business/GetAllComCodePhone?ComCode=" + _Correction.state.comCode + "&UserName=" + value,
                type: "post",
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    //console.log(data)
                    if (data != []) {
                        callback(data);
                    } else {
                        let data = []
                        callback(data);
                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    //console.log(data)
                }
            })
        }
        timeout = setTimeout(fake, 300);
    }
    // 经办人模糊匹配下拉框方法
    HanderNameChange(value) {
        _Correction.props.form.setFieldsValue({
            CP_HanderName: value!=undefined? value.replace(/'/g,''):''
        })
        if (value != undefined) {
            _Correction.Jfetch(value, data => _Correction.setState({ HanderName: data }));
        }
    }
    // 经办人模糊匹配下拉框方法
    HanderNameSelect = (value, option) => {
        setTimeout(function () {
            _Correction.props.form.setFieldsValue({
                CP_HanderPhone: option.key
            })
        }, 20)
    }
    myValidator1 = (rule, value, callback) => {
        //console.log(value);
        if (value != undefined) {
            if (value.length > 20) {
                //console.log('20个字以内');
                callback('20个字以内');
                return;
            } else {
                callback();
            }
        } else {
            callback();
        }
    }



    render() {
        const { autoHeight } = this.state;
        const style = {
            minHeight: autoHeight
        };
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 5, style: { textAlign: "center" } },
            wrapperCol: { span: 16, style: { marginLeft: 0 } }
        };
        const formItemLayout1 = {
            labelCol: { span: 6, style: { textAlign: "center" } },
            wrapperCol: { span: 15, style: { marginLeft: 0 } }
        };
        const head = { 'X-Requested-With': null }
        return (
            <div id='CompormiseCorrection'>
                <div className='CompormiseCorrectionMain' style={{ backgroundColor: '#fff' }}>
                    <div className='CompormiseCorrectionEdit' style={style}>
                        <p>和解信息</p>
                        <Form>
                            <Row>
                                <Col span={8}>
                                    <FormItem
                                        label="和解结果"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('content', {
                                            rules: [
                                                { required: true, message: '请输入退回原因' },
                                            ],
                                        }
                                        )(
                                            <Select size='default' disabled={true}>
                                                <Option value="和解成功">和解成功</Option>
                                                <Option value="和解失败">和解失败</Option>
                                            </Select>
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={8} id='zhengyi'>
                                    <FormItem
                                        label="争议金额(元)"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_DisputeMoney1', {
                                            rules: [{ required: true, message: '请输入争议金额' }],
                                        })(
                                            <InputNumber
                                                style={{ width: '100%' }}
                                                placeholder="单位：元"
                                                min={0.00}
                                                step={1}
                                                precision={2}
                                                max={999999999.99}
                                                //parser={value => value == '' ? '0.00' : value}

                                            />
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={8} id='tuipei'>
                                    <FormItem
                                        label="退赔金额(元)"
                                        {...formItemLayout1}
                                    >
                                        {getFieldDecorator('CP_RedeemLoss1', { rules: [{ required: true, message: '请输入退赔金额值' }], }
                                        )(
                                            <InputNumber style={{ width: '100%' }}
                                            placeholder="单位：元" min={0.00} step={1} precision={2} max={999999999.99}
                                            //parser={value => value == '' ? '0.00' : value}
                                        />
                                           
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8}>
                                    <FormItem
                                        label="经办人"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_HanderName', {
                                            rules: [
                                                { required: true, message: '请输入经办人姓名' }, { validator: this.myValidator1 }
                                            ],
                                        }
                                        )(
                                            <Select
                                                allowClear
                                                mode="combobox"
                                                placeholder="请输入经办人姓名"
                                                defaultActiveFirstOption={false}
                                                showArrow={false}
                                                filterOption={false}
                                                onChange={this.HanderNameChange}
                                                onSelect={this.HanderNameSelect}
                                            >
                                                {
                                                    this.state.HanderName.map(function (e) {
                                                        return <Option key={e.CU_LinkPhone} value={e.CU_UserName}>{e.CU_UserName}</Option>
                                                    })
                                                }
                                            </Select>
                                            )}
                                    </FormItem>
                                </Col>

                                <Col span={8}>
                                    <FormItem
                                        label="经办人电话"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_HanderPhone', {
                                            rules: [{ required: true, message: '请输入联系电话' }, { pattern: /^\d{6,18}$/, message: '请输入有效的联系电话' }],
                                        })(
                                            <Input placeholder="请输入联系电话" />
                                            )}
                                    </FormItem>
                                </Col>

                                <Col span={8}>
                                    <FormItem
                                        label="负责人"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_HeaderName', {
                                            rules: [
                                                { required: true, message: '请输入负责人姓名' }, { validator: this.myValidator1 }
                                            ],
                                        }
                                        )(
                                            <Select
                                                allowClear
                                                mode="combobox"
                                                placeholder="请输入负责人姓名"
                                                defaultActiveFirstOption={false}
                                                showArrow={false}
                                                filterOption={false}
                                                onChange={this.HeaderNameChange}
                                                onSelect={this.onHeaderName}

                                            >
                                                {
                                                    this.state.HeaderName.map(function (e) {
                                                        return <Option key={e.CU_LinkPhone} value={e.CU_UserName}>{e.CU_UserName}</Option>
                                                    })
                                                }
                                            </Select>
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={15}>
                                    <FormItem
                                        label="负责人电话"
                                        labelCol={{ span: 3, style: { textAlign: "center" } }}
                                        wrapperCol={{ span: 9 }}
                                    >
                                        {getFieldDecorator('CP_HeaderPhone', {
                                            rules: [{ required: true, message: '请输入联系电话' }, { pattern: /^\d{6,18}$/, message: '请输入有效的联系电话' }],
                                        })(
                                            <Input placeholder="请输入联系电话" style={{ width: '91%' }} />
                                            )}
                                    </FormItem>
                                </Col>

                            </Row>
                            <Row>
                                <Col span={15}>
                                    <FormItem
                                        label={this.state.neirong}
                                        labelCol={{ span: 3, style: { textAlign: "center" } }}
                                        wrapperCol={{ span: 21 }}
                                    >
                                        {getFieldDecorator('CP_Content', {
                                            rules: [{ required: true, message: '请输入和解结果！' }, { validator: this.myValidator2 }],
                                        }
                                        )(
                                            <TextArea autosize={{ minRows: 6, maxRows: 8 }} placeholder='请输入详细的和解结果，1000字以内' maxLength='1000' />
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem
                                        label="附件上传"
                                        labelCol={{ span: 8, style: { textAlign: "right" } }}
                                        wrapperCol={{ span: 14, style: { marginLeft: 3 } }}
                                    >
                                        {getFieldDecorator('CP_Attach', {
                                            rules: [{ required: false, message: '请输入办理内容' }],
                                        }
                                        )(


                                            (this.state.fileList != null && this.state.fileList.length >= 4) ? <Upload
                                                name="file"
                                                // action="https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx"
                                                action={"https://wisdom.jsca315.org.cn/wisdom315_BusinessAPI_jiangsu/api/HomePage/Uploadfile"}
                                                onChange={this.handleChange}
                                                beforeUpload={this.beforeUpload}
                                                fileList={this.state.fileList}
                                                headers={head}
                                              
                                            ><Button disabled={true}>
                                                    <Icon type="upload" /> 点击上传附件
                                </Button> </Upload> : <Upload
                                                    name="file"
                                                    // action="https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx"
                                                    action={"https://wisdom.jsca315.org.cn/wisdom315_BusinessAPI_jiangsu/api/HomePage/Uploadfile"}
                                                    onChange={this.handleChange}
                                                    beforeUpload={this.beforeUpload}
                                                    fileList={this.state.fileList}
                                                    headers={head}
                                                ><Button >
                                                        <Icon type="upload" /> 点击上传附件
                                </Button> </Upload>)}
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
                <div className='Lcompanybtn'>
                    <Button type='primary' style={{ marginRight: 20 }} onClick={this.SureCorrection} loading={this.state.loading}>确定更正</Button>
                    <Button type='default' onClick={this.WaiveCorrection}>放弃更正</Button>
                </div>
            </div>
        )
    }

}
const AppWrapped = Form.create()(App);
export default AppWrapped


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompormiseListAlready/CompormiseListAlreadyCorrection/CompormiseCorrection.js